import React, { useState, useEffect } from "react";
import themePropTypes from "../theme-prop-types";
import FieldBuilder from "../../fields/fields-builder";
import AlertsContainer from "./alerts-container";
import Toasts from "../../components/toast-notification";

const FixedLayoutFieldsRenderer = ({ screen, appData, components }) => {
  const [mainFields, setMainFields] = useState([]);
  const [leftRailFields, setLeftRailFields] = useState([]);
  const [layoutType, setLayoutType] = useState("");

  const detectWebLayout = (layouts, type) =>
    layouts.find(layout => layout["layout-id"] === type);

  const populateLayoutSection = (
    sectionFields,
    screenFields,
    setFieldsCollection
  ) => {
    const fields = [];
    sectionFields.forEach(sectionField => {
      screenFields.forEach(screenField => {
        if (sectionField === screenField.name) {
          fields.push(screenField);
        }
      });
    });
    setFieldsCollection(fields);
  };

  const updateLayout = () => {
    const layout = window.innerWidth < 768 ? "mobile" : "primary";
    setLayoutType(layout);
  };

  const cleanLayoutSections = () => {
    setLeftRailFields([]);
    setMainFields([]);
  };

  const populateLayoutSections = () => {
    if (layoutType) {
      const layout = detectWebLayout(screen.screenLayouts, layoutType);
      layout.sections.forEach(section => {
        switch (section.name) {
          case "main":
            populateLayoutSection(section.fields, screen.fields, setMainFields);
            break;
          case "left_rail":
            populateLayoutSection(
              section.fields,
              screen.fields,
              setLeftRailFields
            );
            break;
          default:
            /* eslint-disable-next-line no-console */
            console.error("Unknown screen name", screen.name);
        }
      });
    }
  };

  useEffect(() => {
    updateLayout();
    window.addEventListener("resize", updateLayout);

    return () => {
      window.removeEventListener("resize", updateLayout);
    };
  }, []);

  useEffect(() => {
    cleanLayoutSections();
    populateLayoutSections();
  }, [layoutType, screen.fields]);

  const renderFields = (fields, sectionClassName) => (
    <div className={sectionClassName}>
      {fields.map(field => (
        <FieldBuilder
          key={`field_${field.name}`}
          field={field}
          appData={appData}
          components={components}
          screen={screen}
        />
      ))}
    </div>
  );

  return (
    <div className={`screen-web-sdk-new-layout ${screen.name}`}>
      <Toasts
        toasts={appData.toasts}
        onClose={toastId => appData.removeToast(toastId)}
        components={components}
      />
      {screen.dialogs && !!screen.dialogs.length && (
        <AlertsContainer
          components={components}
          appData={appData}
          dialogs={screen.dialogs}
          screen={screen}
        />
      )}
      <div className='mainWrapper'>
        {!!leftRailFields.length && (
          <div className='leftRailColumn'>
            {renderFields(leftRailFields, "leftRailFields")}
          </div>
        )}
        <div className='mainContentColumn'>
          {renderFields(mainFields, "mainFields")}
        </div>
      </div>
    </div>
  );
};

FixedLayoutFieldsRenderer.propTypes = themePropTypes.screen;

export default FixedLayoutFieldsRenderer;
